import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchDrivers = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/drivers', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_DRIVERS,
      payload: {
        drivers: response['hydra:member'],
      },
    });
  });

export const fetchDriver = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/drivers/${id}`).then(response => {
    dispatch({
      type: types.FETCH_DRIVER,
      payload: {
        name: response.name,
        zones: response.zones,
      },
    });
    return response;
  });

export const removeDriver = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/driver/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_DRIVER,
      payload: {
        driverId: id,
      },
    });
  });
